import React, { useState, useEffect } from "react";
import "../src/assets/components/global.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import AutoLogout from "./autologout";
import axios from "axios";

function Listvisitor() {
  const [visitorData, setVisitorData] = useState([]);
  const [selectedVisitor, setSelectedVisitor] = useState(null); // State to hold the selected visitor
  const [firstname, setFirstname] = useState("");
  const [isSearchboxVisible, setSearchboxVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(
        `https://brgytracerappserver.onrender.com/listvisitor?firstname=${firstname}`
      )
      .then((res) => {
        console.log(res.data);
        setVisitorData(res.data.users || []);
      })
      .catch((err) => console.log(err));
  }, [firstname]);

  const handleViewData = (user) => {
    setSearchboxVisible(!isSearchboxVisible);
    setSelectedVisitor(user); // Set the selected visitor when clicking "View"
  };

  const handleSearchInputChange = (e) => {
    setFirstname(e.target.value);
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) =>
      Math.min(prevPage + 1, Math.ceil(visitorData.length / rowsPerPage))
    );
  };

  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = Math.min(startIndex + rowsPerPage, visitorData.length);
  const currentVisitors = visitorData.slice(startIndex, endIndex);

  const handleclose = () => navigate("/officerpage");

  const handleback = () => {
    setSelectedVisitor(null);
    setSearchboxVisible(false);
  };

  return (
    <div className="officerpage-parent listvisitor">
      <AutoLogout />
      <div className="container">
        <div className={`searchbox ${isSearchboxVisible ? "edit-mode" : ""}`}>
          <div>
            <FontAwesomeIcon icon={faSearch} />
            <input
              type="text"
              placeholder="Search by FirstName"
              value={firstname}
              onChange={handleSearchInputChange}
            />
          </div>
        </div>
        <div className="datagrid-parent">
          <button type="btn" className="closebtn" onClick={handleclose}>
            X
          </button>
          <h1>Visitor Details</h1>
          {selectedVisitor ? (
            <div>
              {/* Form to display visitor data */}
              <form className="Visitor-details">
                <div className="photo-container">
                  <img src={selectedVisitor.photo} alt="User Photo" />
                </div>
                <div className="visitor-detail-container">
                  <div>
                    <label>First Name:</label>
                    <input
                      type="text"
                      value={selectedVisitor.firstname}
                      disabled
                    />
                  </div>
                  <div>
                    <label>Middle Name:</label>
                    <input
                      type="text"
                      value={selectedVisitor.middlename}
                      disabled
                    />
                  </div>
                  <div>
                    <label>Last Name:</label>
                    <input
                      type="text"
                      value={selectedVisitor.lastname}
                      disabled
                    />
                  </div>
                  <div>
                    <label>Age:</label>
                    <input type="text" value={selectedVisitor.age} disabled />
                  </div>
                  <div>
                    <label>Gender:</label>
                    <input
                      type="text"
                      value={selectedVisitor.gender}
                      disabled
                    />
                  </div>
                  <div>
                    <label>Contact Number:</label>
                    <input
                      type="text"
                      value={selectedVisitor.cellnumber}
                      disabled
                    />
                  </div>
                  <div>
                    <label>Residency:</label>
                    <input
                      type="text"
                      value={selectedVisitor.residenceof}
                      disabled
                    />
                  </div>
                  <div>
                    <label>referenceperson 1:</label>
                    <input
                      type="text"
                      value={selectedVisitor.referenceperson1}
                      disabled
                    />
                  </div>
                  <div>
                    <label>referenceperson 2:</label>
                    <input
                      type="text"
                      value={selectedVisitor.referenceperson2}
                      disabled
                    />
                  </div>
                </div>
              </form>
              <button className="buttonback" onClick={handleback}>
                back
                {/* onClick={() => setSelectedVisitor(null)}> Back */}
              </button>
            </div>
          ) : currentVisitors.length > 0 ? (
            <div className="datagrid-holder">
              <table>
                <thead>
                  <tr>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Phone</th>
                    <th>DateLogs</th>
                    <th>refperson1</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentVisitors.map((user, index) => (
                    <tr key={`${user.id}-${index}`}>
                      <td>{user.firstname}</td>
                      <td>{user.lastname}</td>
                      <td>{user.cellnumber}</td>
                      <td>{user.dateIn}</td>
                      <td>{user.referenceperson1}</td>
                      <td
                        className="handleEdit"
                        onClick={() => handleViewData(user)}>
                        View
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="pagination-controls">
                <button
                  className="pagination-button"
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}>
                  Previous
                </button>
                <span className="pagination-info">
                  Page {currentPage} of{" "}
                  {Math.ceil(visitorData.length / rowsPerPage)}
                </span>
                <button
                  className="pagination-button"
                  onClick={handleNextPage}
                  disabled={
                    currentPage === Math.ceil(visitorData.length / rowsPerPage)
                  }>
                  Next
                </button>
              </div>
            </div>
          ) : (
            <p className="noUsertext">No users available for display.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Listvisitor;
